"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTableSortIconSort = exports.StyledTableSortIconArrowUp = exports.StyledTableSortIconArrowDown = void 0;
var _TableSortIcon = require("./TableSortIcon");
// TODO: in v9, move styled() from TableSortIcon.jsx to here
var StyledTableSortIconArrowDown = _TableSortIcon.TableSortIconArrowDown;
exports.StyledTableSortIconArrowDown = StyledTableSortIconArrowDown;
var StyledTableSortIconArrowUp = _TableSortIcon.TableSortIconArrowUp;
exports.StyledTableSortIconArrowUp = StyledTableSortIconArrowUp;
var StyledTableSortIconSort = _TableSortIcon.TableSortIconSort;
exports.StyledTableSortIconSort = StyledTableSortIconSort;